import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Brain, Sparkles, CheckCircle2, Shield } from 'lucide-react';

export const PensieveSettingsCard = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Brain className="h-5 w-5 text-purple-500" />
          OptiTime Learning (Automatic)
        </CardTitle>
        <CardDescription>
          OptiBay quietly learns which technicians you prefer for certain kinds of work
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {/* How it works */}
        <div className="space-y-2">
          <h4 className="text-sm font-medium flex items-center gap-2">
            <Sparkles className="h-4 w-4 text-amber-500" />
            How It Works
          </h4>
          <p className="text-sm text-muted-foreground">
            OptiBay learns from repeated manual reassignments and override decisions. 
            Over time, it builds a preference signal for which technician tends to be 
            chosen for certain kinds of work.
          </p>
        </div>

        {/* What triggers learning */}
        <div className="space-y-2">
          <h4 className="text-sm font-medium flex items-center gap-2">
            <CheckCircle2 className="h-4 w-4 text-green-500" />
            What Triggers Learning
          </h4>
          <ul className="text-sm text-muted-foreground space-y-1 ml-6 list-disc">
            <li>Skill match moves (you moved a ticket because the tech has better skills)</li>
            <li>Tech preference moves (you consistently prefer this tech for certain work)</li>
            <li>Customer requests (customer asked for a specific technician)</li>
            <li>Specialty matches (tech specializes in this type of work)</li>
          </ul>
          <p className="text-xs text-muted-foreground mt-2 italic">
            System-driven moves (cascades, weather blocks, capacity balancing) are ignored.
          </p>
        </div>

        {/* Automatic management badge */}
        <div className="bg-muted/50 rounded-lg p-3 flex items-start gap-3">
          <Shield className="h-5 w-5 text-blue-500 mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-sm font-medium">Managed Automatically</p>
            <p className="text-xs text-muted-foreground">
              OptiBay automatically manages learning sensitivity, consistency thresholds, 
              and time windows for stable, predictable behavior. No configuration needed.
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
